{
    "title": "Manage External Wallets",
    "subtitle": "Connect your external wallet below and manage your transactions",
    "sections":{
        "transactions": {
            "title": "Transactions"
        },
        "wallet": {
            "title": "Wallet Information",
            "items": {
                "address": "Address",
                "chain": "Blockchain",
                "key": "Key"
            },
            "connect": "Connect your wallet to start"
        }
    }
}